import PropTypes from 'prop-types';
import React from 'react';
import { graphql, useFragment } from 'react-relay';

import TimeOfUsable from 'src/components/TradeRule/TimeOfUse/TimeOfUsable';

const AdminMeterTradeRulesTableItemClauseFragment = graphql`
  fragment AdminMeterTradeRulesTableItemClause_clause on Clause {
    id
    price
    timezone
    ignorePublicHolidays
    ignoreDaylightSavings
    publicHolidayRegion
    monthsOfYear
    daysOfWeek
    timesOfDay {
      start {
        hours
        minutes
        seconds
      }
      finish {
        hours
        minutes
        seconds
      }
    }
  }
`;

/**
 * Renders a trade rule clause for an admin meter
 * @param {object} props - Component props
 * @param {object} props.clause - The clause data
 * @param {boolean} props.showConditions - Whether to show conditions
 * @returns {React.ReactElement} The rendered component
 */
function AdminMeterTradeRuleTableItemClause(props) {
  const { showConditions } = props;
  let { clause } = props;
  clause = useFragment(AdminMeterTradeRulesTableItemClauseFragment, clause);

  return <TimeOfUsable timeOfUsable={clause} showConditions={showConditions} />;
}

AdminMeterTradeRuleTableItemClause.propTypes = {
  clause: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  showConditions: PropTypes.bool,
};

AdminMeterTradeRuleTableItemClause.defaultProps = {
  showConditions: false,
};

export default AdminMeterTradeRuleTableItemClause;
